export default "{\n    \"skip\": \"Omitir\",\n    \"back\": \"Atrás\",\n    \"next\": \"Siguiente\",\n    \"finish\": \"Finalizar\"\n}"